<template>
  <div class="page">
    <HomeHero></HomeHero>
    <div class="section container has-text-centered">
      <h1 class="title is-size-1">Become an Expert!</h1>
      <p class="subtitle">Show your industry what you know.</p>
    </div>
    <div class="container content">
      <p>Experts are selected based on their industry expertise and knowledge.</p>
      <p>Write articles showing your experience and
        establishing you as a trusted voice in your industry.</p>
      <p>Interested? Check out our expert criteria and fill
        out the form below and we'll get in touch with you.</p>
    </div>
    <div class="section container content">
      <h2 class="has-text-centered">Expert Criteria</h2>
      <ol>
        <li v-for="(criteria, index) in expertCriteria" :key="index">{{ criteria }}</li>
      </ol>
    </div>
    <div id="expertForm" class="section container" v-show="!submitted">
      <form class="form" @submit.prevent="handleSubmit">
        <div class="field is-horizontal">
          <div class="field-body">
            <div class="field">
              <p class="control is-expanded has-icons-left">
                <input
                  v-model="user.email"
                  type="email"
                  class="input"
                  placeholder="Your Email"
                  required
                >
                <span class="icon is-small is-left has-text-grey">
                  <fa icon="envelope"></fa>
                </span>
              </p>
            </div>
            <div class="field">
              <p class="control is-expanded has-icons-left">
                <input
                  v-model="user.name"
                  type="text"
                  class="input"
                  placeholder="Your Name"
                  required
                >
                <span class="icon is-small is-left has-text-grey">
                  <fa icon="user"></fa>
                </span>
              </p>
            </div>
            <button class="button is-success" type="submit">Become an Expert</button>
          </div>
        </div>
      </form>
    </div>
    <div id="expertFormSubmitted" class="section container" v-show="submitted">
      <div class="notification is-primary has-text-centered">
        <p>Thank you for your interest!</p>
        <p>Someone will be in contact with you shortly.</p>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHero from '@/components/HomeHero.vue';

export default {
  data() {
    return {
      submitted: false,
      user: {
        email: '',
        name: '',
      },
    };
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
    },
  },
  computed: {
    expertCriteria() {
      return this.$store.state.expert.criteria;
    },
  },
  components: {
    HomeHero,
  },
};
</script>
